export default "__VITE_ASSET__DMTQXmud__"